import React, { useState, useEffect } from 'react';
import Editor from './Editor';

const ShowHtmlEditor = ({ PageContent, setPageContent, HandleForm, ForAttribute }) => {
    const RYEditor = 1;
    const [isEditview, setisEditview] = useState(PageContent ? 0 : 1);
    function getContent(value) {
        setPageContent(value);
        HandleForm(ForAttribute, value);
    }
    useEffect(() => {
        // setisEditview(PageContent ? 1 : 0);
    }, []);
    return (
        <div ry={RYEditor}>
            {/* #{PageContent.length}# */}
            {/* ##{isEditview}## */}
            <div>
                <Editor
                    getContent={getContent}
                    PageContent={PageContent}
                    isEditview={isEditview}
                    setisEditview={setisEditview}
                    setPageContent={setPageContent}
                />
            </div>
        </div>
    );
};

export default ShowHtmlEditor;
